import { useRouter } from 'next/router'
import { useGQLClient } from './use-gql-clients'

type TUserMode = 'staff' | 'parent'

export const useGqlController = () => {
  const { query, isReady: isRouterReady, push } = useRouter()
  const { mode } = query
  const { gqlClient, isClientReady } = useGQLClient(mode as TUserMode)

  return {
    isReady: isRouterReady && isClientReady,
    gqlClient,
    query,
    push,
  }
}
